import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SettingsPage from '../Settings';
import CompanyProfilePage from '../CompanyProfilePage';
import ManagementSetup from '../ManagementSetup';
import RetellManagement from '../RetellManagement';
import SettingsRetellManagement from '../SettingsRetellManagement';
import SettingsOperationsLanding from '../SettingsOperationsLanding';
import HRLanding from '../HRLanding';
import UsersAndPermissionsLanding from '../UsersAndPermissionsLanding';
import FinanceLanding from '../modules/finance/pages/FinanceLanding';
import UsersPage from '../UsersPage';
import RolesPage from '../RolesPage';
import PartsCategoriesPage from '../PartsCategoriesPage';
import CustomListsPage from '../CustomListsPage';
import SettingsDispatchCategories from '../SettingsDispatchCategories';
import SettingsJobStatusColors from '../SettingsJobStatusColors';
import SalesOrderSetupPage from '../SalesOrderSetupPage';
import EmployeeStatusPage from '../EmployeeStatusPage';
import DepartmentsPage from '../DepartmentsPage';
import NominalCodesPage from '../NominalCodesPage';
import CISReverseVATPage from '../CISReverseVATPage';
import PPMPaymentTermsPage from '../PPMPaymentTermsPage';
import PPMDiscountTiersPage from '../PPMDiscountTiersPage';
import PPMPricingPage from '../PPMPricingPage';
import NumberFormatsPage from '../NumberFormatsPage';
import DataPage from '../DataPage';
import AIConfigPage from '../AIConfigPage';
import DocumentTemplateLibrariesSetup from '../DocumentTemplateLibrariesSetup';
import DocumentTemplatePlacementsSetup from '../DocumentTemplatePlacementsSetup';
import SettingsDocumentDesign from '../SettingsDocumentDesign';
import FormDesignerPage from '../FormDesignerPage';
import SettingsMarketingImageGeneration from '../SettingsMarketingImageGeneration';

const SettingRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<SettingsPage />} />
      <Route path="templates" element={<SettingsPage defaultSection="text-templates" />} />
      <Route path="text-templates" element={<SettingsPage defaultSection="text-templates" />} />
      <Route path="company-profile" element={<CompanyProfilePage />} />
      <Route path="modules" element={<SettingsPage defaultSection="modules" />} />
      <Route path="users" element={<UsersPage />} />
      <Route path="users-and-permissions" element={<UsersAndPermissionsLanding />} />
      <Route path="roles" element={<RolesPage />} />
      <Route path="numbers-all" element={<SettingsPage defaultSection="numbers-all" />} />
      <Route path="number-formats" element={<NumberFormatsPage />} />
      <Route path="list-creation" element={<SettingsPage defaultSection="list-creation" />} />
      <Route path="operations-files" element={<SettingsOperationsLanding />} />
      <Route path="dispatch" element={<SettingsOperationsLanding />} />
      <Route path="hr" element={<HRLanding />} />
      <Route path="employee-status" element={<EmployeeStatusPage />} />
      <Route path="departments" element={<DepartmentsPage />} />
      <Route path="parts-categories" element={<PartsCategoriesPage />} />
      <Route path="custom-lists" element={<CustomListsPage />} />
      <Route path="dispatch-categories" element={<SettingsDispatchCategories />} />
      <Route path="job-status-colors" element={<SettingsJobStatusColors />} />
      <Route path="sales-order-setup" element={<SalesOrderSetupPage />} />
      <Route path="document-template-libraries" element={<DocumentTemplateLibrariesSetup />} />
      <Route path="document-template-placements" element={<DocumentTemplatePlacementsSetup />} />
      <Route path="marketing-image-generation" element={<SettingsMarketingImageGeneration />} />
      <Route path="document-design" element={<SettingsDocumentDesign />} />
      <Route path="form-question-lists" element={<FormDesignerPage />} />
      <Route path="ppm-pricing" element={<PPMPricingPage />} />
      <Route path="ppm-payment-terms" element={<PPMPaymentTermsPage />} />
      <Route path="ppm-discount-tiers" element={<PPMDiscountTiersPage />} />
      <Route path="finance-setup" element={<FinanceLanding />} />
      <Route path="nominal-codes" element={<NominalCodesPage />} />
      <Route path="cis-reverse-vat" element={<CISReverseVATPage />} />
      <Route path="import-data" element={<DataPage />} />
      <Route path="data" element={<DataPage />} />
      <Route path="ai-config" element={<AIConfigPage />} />
      <Route path="management-setup" element={<ManagementSetup />} />
      <Route path="management-hub" element={<RetellManagement />} />
      <Route path="management-diagnostics" element={<RetellManagement initialSection="diagnostics" />} />
      <Route path="additional-modules" element={<RetellManagement initialSection="modules" />} />
      <Route path="retell-management" element={<SettingsRetellManagement />} />
    </Routes>
  );
};

export default SettingRoutes;
